import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#i-1006370714__a)\"><rect width=\"64\" height=\"64\" fill=\"#29292F\" rx=\"32\"></rect><circle cx=\"32\" cy=\"24\" r=\"14.4\" fill=\"#FCC1C8\"></circle><path fill=\"#FCC1C8\" d=\"M28.409 37.327h7.182v7.514h-7.182z\"></path><path fill=\"#000\" fill-rule=\"evenodd\" d=\"M46.1 21.062A35.08 35.08 0 0 1 32 24a35.082 35.082 0 0 1-14.1-2.938C19.255 14.518 25.052 9.6 32 9.6c6.946 0 12.743 4.918 14.1 11.462Z\" clip-rule=\"evenodd\"></path><circle cx=\"32\" cy=\"83.2\" r=\"40\" fill=\"#009B76\"></circle></g><defs><clipPath id=\"i-1006370714__a\"><rect width=\"64\" height=\"64\" fill=\"#fff\" rx=\"32\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }